import React from 'react';
import {FormControl, FormHelperText, TextField} from "material-ui";

export const renderDateField = ({
                                    input,
                                    meta: {touched, error},
                                    ...custom
                                }) => (

    <FormControl fullWidth
                 margin="normal"
                 error={custom.err !== undefined && custom.err !== null}>
        <TextField
            {...input}
            {...custom}
            InputLabelProps={{
                shrink: true,
            }}
        />
        {custom.err !== undefined && custom.err !== null ?
            custom.err.map((n, i) =>
                <FormHelperText key={i}>{n}</FormHelperText>) : null}
    </FormControl>
);


// WEBPACK FOOTER //
// ./src/forms/inputs/DateFeaild.js